import { NavLink, ThemeIcon } from '@mantine/core';
import { IconFileText } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums';

interface TermDocumentsLinkProps {
  navigate(to: string): void;
  themeColor: 'dark' | 'light';
}

export function TermDocumentsLink({
  navigate,
  themeColor,
}: TermDocumentsLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: themeColor === 'light' ? '#373A40' : '#FBFBFB',
        },
      }}
      label="Docs"
      fw="bold"
      icon={
        <ThemeIcon color="teal" variant="light">
          <IconFileText size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Listagem"
        onClick={() => navigate(AppRoutePaths.TERM_DOCUMENTS)}
      />
    </NavLink>
  );
}
